/** Resolves the app locale to the locale used by platform formatters and providers. */
export function resolveDisplayLocale(locale: string): 'en-US' | 'es-419' {
  return locale === 'es' ? 'es-419' : 'en-US'
}
